import { Signature } from '../../../types/user';
import { getExpirationDateMessage } from '../../../util/subscription';
import { ItemSignature, TitleProduct } from '../styles';

export const ItemEditoraSignature = ({
  signatures,
}: {
  signatures: Signature[];
}) => {
  return (
    <>
      {signatures.map((s, i) => (
        <ItemSignature key={`signature-${String(i)}`}>
          <TitleProduct>{s.name}</TitleProduct>
          {s.expirationDate && (
            <p>{getExpirationDateMessage(s.expirationDate)}</p>
          )}
          <p>{s.message}</p>
        </ItemSignature>
      ))}
    </>
  );
};
